export const apiHost =
  process.env.REACT_APP_API_HOST ||
  `${window.location.protocol}//${window.location.host}`;
